module.exports = __webpack_public_path__ + "static/img/1064_phase_function_Paper_Points.63b43f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1064_phase_function_Paper_Points.png
// module id = /sgz
// module chunks = 0